import axios from 'axios'

export const GetRegulationData = () =>
    axios.get(`/ProgramRules/Regulation`).then((response) => response?.data)

export const PostRegulationData = (obj) =>
    axios
        .post(`/Consumer/SetConsumerRegulationRules`, obj)
        .then((response) => response?.data)
